import { render, staticRenderFns } from "./profile-change-password.vue?vue&type=template&id=607d6291&scoped=true&"
import script from "./profile-change-password.vue?vue&type=script&lang=js&"
export * from "./profile-change-password.vue?vue&type=script&lang=js&"
import style0 from "./profile-change-password.vue?vue&type=style&index=0&id=607d6291&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d6291",
  null
  
)

export default component.exports